import * as React from "react"
import Swiper, { ReactIdSwiperProps, SwiperInstance } from "react-id-swiper"
import "./content.scss"

interface IContentContent {
  past?: string
  present?: string
  future?: string
}

interface IProps {
  content: IContentContent
}


export const Content: React.FC<IProps> = props => {
  const { content } = props


  const capitalise = React.useCallback((string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }, [])

  const [swiper, setSwiper] = React.useState<SwiperInstance>()
  const [eventsHook, setEventsHook] = React.useState(false)
  const [active, setActive] = React.useState<"past" | "present" | "future">("past")

  const swiperParams2: ReactIdSwiperProps = {
    containerClass: "swiper-container-2-hello",
    resistanceRatio: 0,
    slidesPerView: 1,
    observer: true,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => {
        return `<span class="${className}">${capitalise(Object.keys(content)[index])}</span>`
      }
    },
    getSwiper: (swiper) => setSwiper(swiper)
  }


  React.useEffect(() => {
    if (swiper) {
      swiper.on("slideChange", () => swiper.update())

      return () => {
        swiper.off("slideChange")
      }
    }
  }, [swiper])

  return (
    // <Swiper {...swiperParams2}>
    <>
      <div className="tabs">
        <button data-active={active === "past"} onClick={() => setActive("past")}>Past</button>
        <button data-active={active === "present"} onClick={() => setActive("present")}>Present</button>
        <button data-active={active === "future"} onClick={() => setActive("future")}>Future</button>
      </div>
      <div className="tab-section-container">
        {active === "past" && <Scroller content={content.past} />}
        {active === "present" && <Scroller content={content.present} />}
        {active === "future" && <Scroller content={content.future} />}
      </div>
    </>
  )
}

const Scroller: React.FC<{ content: string }> = ({ content }) => {
  return (
    <div className="tab-section">
      <Swiper
        containerClass="scroll-swiper"
        resistanceRatio={0}
        direction={"vertical"}
        freeMode={true}
        nested={true}
        slidesOffsetAfter={-300}
      >
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
        <div className="rocketmakers-logo-block">
          <span className="powered-by">Powered by:</span>
          <a href="https://www.rocketmakers.com/">
            <img src={require("../assets/images/rocketmakers-logo-black.svg")} alt="Rocketmakers company logo" className="rocketmakers-logo" />
          </a>
        </div>
      </Swiper>
    </div>
  )
}